import { render, staticRenderFns } from "./TodoItemNode.vue?vue&type=template&id=521e99e5&scoped=true&"
import script from "./TodoItemNode.vue?vue&type=script&lang=js&"
export * from "./TodoItemNode.vue?vue&type=script&lang=js&"
import style0 from "./TodoItemNode.vue?vue&type=style&index=0&id=521e99e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e99e5",
  null
  
)

export default component.exports